export const AreasEndpoint = {
    area: `${process.env.API_BACKEND}/v1/areas/area/`,
} as const
